import { useCallback, useState } from "react";
import { connect } from "react-redux";

import { useNavigate } from "../utils/components/router";
import KundenFormMA from "./KundenFormMA";
import { kundenActions } from "../actions";
import CONFIG from "../config";
import { ErrorMessage } from "./components";
import { PERSONART } from "../utils/enums";

const KundenCreateMA = (props = {}) => {
  const navigate = useNavigate();
  const { configStorage, basketStorage, kundenStorage, mandantStorage, dispatch } = props;
  const contextNavigate = configStorage.contextNavigate(navigate);
  const [state, setState] = useState({ error: null });

  const onSubmit = useCallback(async (formValues) => {
    /* disabled in rev 19582 in KundenFormMa but returned always in formValues */
    formValues.rechtlichesHinweis1 = 1;
    formValues.rechtlichesHinweis2 = 1;
    delete formValues.email2;
    if (formValues.personArt === PERSONART.JURISTISCHE_PERSON.KUERZEL) {
      formValues.vorname = "";
    }

    let requestDataKundenEntry = configStorage.getRequestData("kunde", "post", {
      kunde: { ...formValues, userId: "Testuser" }
    });
    const result = await dispatch(kundenActions.fetchEntry(requestDataKundenEntry))
      .catch(err => {
        setState({ error: err });
      });
    const kundenId = (result && result.id) || kundenStorage.getKundenId() || kundenStorage.kunde.id;
    if (kundenId) {
      if (
        (basketStorage.selectedFiliale !== null && basketStorage.hasFilialChoice) ||
        (mandantStorage && !mandantStorage.lieferadresseIsEditable())
      ) {
        contextNavigate(CONFIG.LINK_FILIALELIEFERUNG);
      } else {
        contextNavigate(`${CONFIG.LINK_KUNDEN_ADDRESSE_MA}${kundenId}`);
      }
    } else {
      if (result) {
        setState({ error: new Error("Es wurde kein gültiger Kunde angelegt.") });
      }
    }
  }, [basketStorage.hasFilialChoice, basketStorage.selectedFiliale, configStorage, contextNavigate, dispatch, kundenStorage, mandantStorage]);

  return (
    <>
      <KundenFormMA
        onSubmit={onSubmit}
        initialValues={{
          isMaShop: props.configStorage.isMaShop()
        }}
      />
      <ErrorMessage text="Beim Speichen ist ein Fehler aufgetreten:" error={state.error} />
    </>
  );
};

export default connect(store => {
  return {
    basketStorage: store.basketStorage,
    kundenStorage: store.kundenStorage,
    configStorage: store.configStorage,
    mandantStorage: store.mandantStorage
  };
})(KundenCreateMA);
